/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetApiPlacementAssuranceVie400,
  GetApiPlacementAssuranceVie403,
  GetApiPlacementDefiscalisation400,
  GetApiPlacementDefiscalisation403,
  GetApiPlacementDetails403,
  GetApiPlacementEligible403,
  GetApiPlacementImmobilier400,
  GetApiPlacementImmobilier403,
  GetApiPlacementLivret400,
  GetApiPlacementLivret403,
  GetApiPlacementOperations403,
  GetApiPlacementRetraite400,
  GetApiPlacementRetraite403,
  PlacementAssuranceVieResponse,
  PlacementDefiscalisationResponse,
  PlacementDetailsResponse,
  PlacementImmobilierResponse,
  PlacementLivretResponse,
  PlacementOperationsResponse,
  PlacementRetraiteResponse,
  VersementResult,
} from '../placementApi.schemas.ts';

import getApiPlacementAssuranceVieMutator from '.././mutator/placement-instance.ts';
import getApiPlacementDefiscalisationMutator from '.././mutator/placement-instance.ts';
import getApiPlacementDetailsMutator from '.././mutator/placement-instance.ts';
import getApiPlacementEligibleMutator from '.././mutator/placement-instance.ts';
import getApiPlacementImmobilierMutator from '.././mutator/placement-instance.ts';
import getApiPlacementLivretMutator from '.././mutator/placement-instance.ts';
import getApiPlacementOperationsMutator from '.././mutator/placement-instance.ts';
import getApiPlacementRetraiteMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation de l'ensemble des elements pour la gestion d'un placement assurance vie de l'application mobile
 * @summary Recuperation d'un placement Assurance vie
 */
export const getApiPlacementAssuranceVie = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementAssuranceVieMutator<PlacementAssuranceVieResponse>({
    url: `/api/placement/assurancevie/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementAssuranceVieQueryKey = (idPlacement: string) => {
  return [`/api/placement/assurancevie/${idPlacement}`] as const;
};

export const getGetApiPlacementAssuranceVieQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
  TError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementAssuranceVieQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>> = ({ signal }) =>
    getApiPlacementAssuranceVie(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementAssuranceVieQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>
>;
export type GetApiPlacementAssuranceVieQueryError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403;

export function useGetApiPlacementAssuranceVie<
  TData = Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
  TError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementAssuranceVie<
  TData = Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
  TError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementAssuranceVie<
  TData = Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
  TError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un placement Assurance vie
 */

export function useGetApiPlacementAssuranceVie<
  TData = Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>,
  TError = GetApiPlacementAssuranceVie400 | GetApiPlacementAssuranceVie403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementAssuranceVie>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementAssuranceVieQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion d'un placement Defiscalisation de l'application mobile
 * @summary Recuperation d'un placement Defiscalisation
 */
export const getApiPlacementDefiscalisation = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementDefiscalisationMutator<PlacementDefiscalisationResponse>({
    url: `/api/placement/defiscalisation/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementDefiscalisationQueryKey = (idPlacement: string) => {
  return [`/api/placement/defiscalisation/${idPlacement}`] as const;
};

export const getGetApiPlacementDefiscalisationQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
  TError = GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementDefiscalisationQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>> = ({ signal }) =>
    getApiPlacementDefiscalisation(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementDefiscalisationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>
>;
export type GetApiPlacementDefiscalisationQueryError =
  GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403;

export function useGetApiPlacementDefiscalisation<
  TData = Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
  TError = GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementDefiscalisation<
  TData = Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
  TError = GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementDefiscalisation<
  TData = Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
  TError = GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un placement Defiscalisation
 */

export function useGetApiPlacementDefiscalisation<
  TData = Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>,
  TError = GetApiPlacementDefiscalisation400 | GetApiPlacementDefiscalisation403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDefiscalisation>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementDefiscalisationQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion de l'affichage du details d'investissement d'un placement de l'application mobile
 * @summary Recuperation du details d'investissement d'un placement
 */
export const getApiPlacementDetails = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementDetailsMutator<PlacementDetailsResponse>({
    url: `/api/placement/details/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementDetailsQueryKey = (idPlacement: string) => {
  return [`/api/placement/details/${idPlacement}`] as const;
};

export const getGetApiPlacementDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementDetails>>,
  TError = GetApiPlacementDetails403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementDetailsQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementDetails>>> = ({ signal }) =>
    getApiPlacementDetails(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementDetails>>>;
export type GetApiPlacementDetailsQueryError = GetApiPlacementDetails403;

export function useGetApiPlacementDetails<
  TData = Awaited<ReturnType<typeof getApiPlacementDetails>>,
  TError = GetApiPlacementDetails403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementDetails<
  TData = Awaited<ReturnType<typeof getApiPlacementDetails>>,
  TError = GetApiPlacementDetails403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementDetails>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementDetails>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementDetails<
  TData = Awaited<ReturnType<typeof getApiPlacementDetails>>,
  TError = GetApiPlacementDetails403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation du details d'investissement d'un placement
 */

export function useGetApiPlacementDetails<
  TData = Awaited<ReturnType<typeof getApiPlacementDetails>>,
  TError = GetApiPlacementDetails403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementDetails>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementDetailsQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Verification de l'éligibilité d'un placement au reversement
 * @summary Verification de l'éligibilité d'un placement au reversement
 */
export const getApiPlacementEligible = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementEligibleMutator<VersementResult>({
    url: `/api/placement/eligible/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementEligibleQueryKey = (idPlacement: string) => {
  return [`/api/placement/eligible/${idPlacement}`] as const;
};

export const getGetApiPlacementEligibleQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementEligible>>,
  TError = GetApiPlacementEligible403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementEligibleQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementEligible>>> = ({ signal }) =>
    getApiPlacementEligible(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementEligibleQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementEligible>>>;
export type GetApiPlacementEligibleQueryError = GetApiPlacementEligible403;

export function useGetApiPlacementEligible<
  TData = Awaited<ReturnType<typeof getApiPlacementEligible>>,
  TError = GetApiPlacementEligible403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementEligible>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementEligible>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementEligible<
  TData = Awaited<ReturnType<typeof getApiPlacementEligible>>,
  TError = GetApiPlacementEligible403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementEligible>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementEligible>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementEligible<
  TData = Awaited<ReturnType<typeof getApiPlacementEligible>>,
  TError = GetApiPlacementEligible403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Verification de l'éligibilité d'un placement au reversement
 */

export function useGetApiPlacementEligible<
  TData = Awaited<ReturnType<typeof getApiPlacementEligible>>,
  TError = GetApiPlacementEligible403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementEligible>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementEligibleQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion d'un placement Immobilier de l'application mobile
 * @summary Recuperation d'un placement Immobilier
 */
export const getApiPlacementImmobilier = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementImmobilierMutator<PlacementImmobilierResponse>({
    url: `/api/placement/immobilier/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementImmobilierQueryKey = (idPlacement: string) => {
  return [`/api/placement/immobilier/${idPlacement}`] as const;
};

export const getGetApiPlacementImmobilierQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
  TError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementImmobilierQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementImmobilier>>> = ({ signal }) =>
    getApiPlacementImmobilier(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementImmobilierQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementImmobilier>>>;
export type GetApiPlacementImmobilierQueryError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403;

export function useGetApiPlacementImmobilier<
  TData = Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
  TError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementImmobilier>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementImmobilier<
  TData = Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
  TError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementImmobilier>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementImmobilier<
  TData = Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
  TError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un placement Immobilier
 */

export function useGetApiPlacementImmobilier<
  TData = Awaited<ReturnType<typeof getApiPlacementImmobilier>>,
  TError = GetApiPlacementImmobilier400 | GetApiPlacementImmobilier403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementImmobilier>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementImmobilierQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion d'un placement Livret de l'application mobile
 * @summary Recuperation d'un placement Livret
 */
export const getApiPlacementLivret = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementLivretMutator<PlacementLivretResponse>({
    url: `/api/placement/livret/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementLivretQueryKey = (idPlacement: string) => {
  return [`/api/placement/livret/${idPlacement}`] as const;
};

export const getGetApiPlacementLivretQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementLivret>>,
  TError = GetApiPlacementLivret400 | GetApiPlacementLivret403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementLivretQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementLivret>>> = ({ signal }) =>
    getApiPlacementLivret(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementLivretQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementLivret>>>;
export type GetApiPlacementLivretQueryError = GetApiPlacementLivret400 | GetApiPlacementLivret403;

export function useGetApiPlacementLivret<
  TData = Awaited<ReturnType<typeof getApiPlacementLivret>>,
  TError = GetApiPlacementLivret400 | GetApiPlacementLivret403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementLivret>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementLivret>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementLivret<
  TData = Awaited<ReturnType<typeof getApiPlacementLivret>>,
  TError = GetApiPlacementLivret400 | GetApiPlacementLivret403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementLivret>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementLivret>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementLivret<
  TData = Awaited<ReturnType<typeof getApiPlacementLivret>>,
  TError = GetApiPlacementLivret400 | GetApiPlacementLivret403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un placement Livret
 */

export function useGetApiPlacementLivret<
  TData = Awaited<ReturnType<typeof getApiPlacementLivret>>,
  TError = GetApiPlacementLivret400 | GetApiPlacementLivret403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementLivret>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementLivretQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion de l'affichage des operations d'un placement de l'application mobile
 * @summary Recuperation des operations d'un placement
 */
export const getApiPlacementOperations = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementOperationsMutator<PlacementOperationsResponse>({
    url: `/api/placement/operations/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementOperationsQueryKey = (idPlacement: string) => {
  return [`/api/placement/operations/${idPlacement}`] as const;
};

export const getGetApiPlacementOperationsQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementOperations>>,
  TError = GetApiPlacementOperations403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementOperationsQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementOperations>>> = ({ signal }) =>
    getApiPlacementOperations(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementOperationsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementOperations>>>;
export type GetApiPlacementOperationsQueryError = GetApiPlacementOperations403;

export function useGetApiPlacementOperations<
  TData = Awaited<ReturnType<typeof getApiPlacementOperations>>,
  TError = GetApiPlacementOperations403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementOperations>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementOperations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementOperations<
  TData = Awaited<ReturnType<typeof getApiPlacementOperations>>,
  TError = GetApiPlacementOperations403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementOperations>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementOperations>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementOperations<
  TData = Awaited<ReturnType<typeof getApiPlacementOperations>>,
  TError = GetApiPlacementOperations403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation des operations d'un placement
 */

export function useGetApiPlacementOperations<
  TData = Awaited<ReturnType<typeof getApiPlacementOperations>>,
  TError = GetApiPlacementOperations403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementOperations>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementOperationsQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation de l'ensemble des elements pour la gestion d'un placement Retraite de l'application mobile
 * @summary Recuperation d'un placement Retraite
 */
export const getApiPlacementRetraite = (idPlacement: string, signal?: AbortSignal) => {
  return getApiPlacementRetraiteMutator<PlacementRetraiteResponse>({
    url: `/api/placement/retraite/${idPlacement}`,
    method: 'GET',
    signal,
  });
};

export const getGetApiPlacementRetraiteQueryKey = (idPlacement: string) => {
  return [`/api/placement/retraite/${idPlacement}`] as const;
};

export const getGetApiPlacementRetraiteQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiPlacementRetraite>>,
  TError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiPlacementRetraiteQueryKey(idPlacement);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPlacementRetraite>>> = ({ signal }) =>
    getApiPlacementRetraite(idPlacement, signal);

  return {
    queryKey,
    queryFn,
    enabled: idPlacement !== null && idPlacement !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiPlacementRetraiteQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPlacementRetraite>>>;
export type GetApiPlacementRetraiteQueryError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403;

export function useGetApiPlacementRetraite<
  TData = Awaited<ReturnType<typeof getApiPlacementRetraite>>,
  TError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403,
>(
  idPlacement: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementRetraite>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementRetraite>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementRetraite<
  TData = Awaited<ReturnType<typeof getApiPlacementRetraite>>,
  TError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403,
>(
  idPlacement: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiPlacementRetraite>>,
          TError,
          Awaited<ReturnType<typeof getApiPlacementRetraite>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiPlacementRetraite<
  TData = Awaited<ReturnType<typeof getApiPlacementRetraite>>,
  TError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation d'un placement Retraite
 */

export function useGetApiPlacementRetraite<
  TData = Awaited<ReturnType<typeof getApiPlacementRetraite>>,
  TError = GetApiPlacementRetraite400 | GetApiPlacementRetraite403,
>(
  idPlacement: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiPlacementRetraite>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiPlacementRetraiteQueryOptions(idPlacement, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
